import "./feedback.css";
import React, { useState } from 'react';
import { sendFeedback } from '../../services/profile';

export default function FeedbackModal({ onClose, userId }) {
  const [type, setType] = useState(''); // новый селект
  const [text, setText] = useState('');
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async () => {
        if (!type) {
      setError("Выберите тип обратной связи");
      return;
    }
    setLoading(true);
    setError('');
    try {
      await sendFeedback({ type, text});
      setSuccess(true);
    } catch (e) {
      setError('Не удалось отправить обратную связь');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-card" onClick={e => e.stopPropagation()}>
        <h2>Обратная связь</h2>

        {success ? (
          <div className="feedback-success">
            Спасибо за вашу обратную связь!
            <div>
              <button onClick={onClose} className="btn primary">Закрыть</button>
            </div>
          </div>
        ) : (
          <>
            <label>Тип обратной связи:</label>
            <select value={type} onChange={e => setType(e.target.value)} className="feedback-select">
              <option value="Отзыв">Отзыв</option>
              <option value="Баг">Баг</option>
              <option value=""></option>
            </select>

            <label>Комментарий:</label>
            <textarea
              value={text}
              onChange={e => setText(e.target.value)}
              placeholder="Ваш комментарий..."
            />

            {error && <div className="feedback-error">{error}</div>}

            <div className="modal-actions">
              <button onClick={onClose} className="btn secondary">Отмена</button>
              <button onClick={handleSubmit} className="btn primary" disabled={loading}>
                {loading ? 'Отправка...' : 'Отправить'}
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
